
export interface Pagination {
  currentPage: number;
  perPage: number;
  totalRecords: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export const EMPTY_PAGINATION = (page = 1, limit = 25): Pagination => ({
  currentPage: page,
  perPage: limit,
  totalRecords: 0,
  totalPages: 0,
  hasNextPage: false,
  hasPreviousPage: false,
});


export interface ApiSuccessResponse<T> {
  success: true;
  data: T;
  message?: string;
  pagination?: Pagination;
}

export interface ApiErrorResponse {
  success: false;
  message: string;
}


export interface StatusHistoryItem {
  status?: string | null;
  date?: string | null;
  time?: string | null;
}


export type CandidateStatusRaw =
  | string
  | StatusHistoryItem
  | StatusHistoryItem[]
  | null
  | undefined;
